module.exports = "/static/media/dtmf-2.ea995f1b.mp3";